import React, { createContext, useState, ReactNode } from 'react';

import { RolesTypes } from 'types/RolesTypes';

interface RolesUserContextProps {
	listRoles: RolesTypes[];
	setListRoles: React.Dispatch<React.SetStateAction<RolesTypes[]>>;
	isSearchingRoles: boolean;
	setIsSearchingRoles: React.Dispatch<React.SetStateAction<boolean>>;
}

const RolesUserContext = createContext<RolesUserContextProps>({
	listRoles: [],
	setListRoles: () => {},
	isSearchingRoles: false,
	setIsSearchingRoles: () => {}
});

interface ContextProps {
	children: ReactNode;
}

export function RolesUserProvider({ children }: ContextProps) {
	const [listRoles, setListRoles] = useState<RolesTypes[]>([]);
	const [isSearchingRoles, setIsSearchingRoles] = useState(false);

	return (
		<RolesUserContext.Provider
			value={{ listRoles, setListRoles, isSearchingRoles, setIsSearchingRoles }}
		>
			{children}
		</RolesUserContext.Provider>
	);
}

export default RolesUserContext;
